import React, { FC } from "react"
import { LocationProvider } from "./locationContext"

const Location: FC = ({ children }) => {
  const [state, setState] = React.useState({ location: { lat: "", lng: "" } })

  const updateLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        setState(prevState => ({
          ...prevState,
          location: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
        }))
      })
    }
  }

  React.useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        setState(prevState => ({
          ...prevState,
          location: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
        }))
      })
    }
  }, [])

  const providerValue = {
    ...state,
    setState: setState,
    updateLocation: updateLocation,
  }

  return <LocationProvider value={providerValue}>{children}</LocationProvider>
}

export default Location
